export const siteConfig = {
  name: "蜜桃影视",
  tagline: "热门影视资源在线观看平台",
  description: "蜜桃影视是您发现热门电影、电视剧、综艺节目的首选平台，海量高清资源随时在线观看，支持多终端播放，让您随时随地享受优质影视娱乐体验。",
  url: "https://flixpeach.github.io",
  logo: "蜜桃影视",
};

export const navLinks = [
  { label: "首页", path: "/" },
  { label: "电影", path: "/category/movie" },
  { label: "电视剧", path: "/category/tv" },
  { label: "综艺", path: "/category/variety" },
  { label: "动漫", path: "/category/anime" },
  { label: "关于我们", path: "/about" },
];

export const footerLinks = {
  categories: [
    { label: "热门电影", path: "/category/movie" },
    { label: "电视剧", path: "/category/tv" },
    { label: "综艺节目", path: "/category/variety" },
    { label: "动漫番剧", path: "/category/anime" },
    { label: "纪录片", path: "/category/documentary" },
  ],
  about: [
    { label: "关于蜜桃影视", path: "/about" },
    { label: "联系我们", path: "/about#contact" },
    { label: "用户协议", path: "/" },
    { label: "隐私政策", path: "/" },
    { label: "版权声明", path: "/" },
  ],
};